import { createContext } from 'react';

import { FormatterWithPrecision } from '../../core/types/formatter.js';

export const HistogramYFormatterContext = createContext<
  FormatterWithPrecision[] | undefined
>(undefined);

HistogramYFormatterContext['displayName'] = 'HistogramYFormatterContext';
